// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"fc58b2c9","853":"891646d2"}[chunkId] + ".chunk.css";
};